import { render, staticRenderFns } from "./ImportImageButton.vue?vue&type=template&id=52d22fac&"
import script from "./ImportImageButton.vue?vue&type=script&lang=js&"
export * from "./ImportImageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports